import { defineComponent, mergeModels, useModel, ref, computed, watch, createElementBlock, openBlock, normalizeClass, createElementVNode, createVNode, toDisplayString, unref, withCtx, createBlock, useTemplateRef, shallowRef, createTextVNode, Fragment, withModifiers, renderList, createCommentVNode } from "vue";
import { mdiFolder, mdiFile, mdiClose, mdiArrowRight } from "@mdi/js";
import NcButton from "@nextcloud/vue/components/NcButton";
import NcCheckboxRadioSwitch from "@nextcloud/vue/components/NcCheckboxRadioSwitch";
import NcDialog from "@nextcloud/vue/components/NcDialog";
import NcIconSvgWrapper from "@nextcloud/vue/components/NcIconSvgWrapper";
import { FileType } from "@nextcloud/files";
import NcDateTime from "@nextcloud/vue/components/NcDateTime";
import { g as getPreviewURL } from "./preview-BIbJGxXF.mjs";
import { t, n, l as logger, s as showError } from "./index-hZPKu-D6.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1$1 = ["src"];
const _hoisted_2$1 = { key: 1 };
const _hoisted_3 = ["src"];
const _hoisted_4 = { key: 1 };
const PREVIEW_SIZE = 64;
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "ConflictPickerEntry",
  props: /* @__PURE__ */ mergeModels({
    existing: {},
    incoming: {}
  }, {
    "existingSelected": { type: Boolean, ...{ required: true } },
    "existingSelectedModifiers": {},
    "incomingSelected": { type: Boolean, ...{ required: true } },
    "incomingSelectedModifiers": {}
  }),
  emits: ["update:existingSelected", "update:incomingSelected"],
  setup(__props, { expose: __expose }) {
    const existingSelected = useModel(__props, "existingSelected");
    const incomingSelected = useModel(__props, "incomingSelected");
    const props = __props;
    __expose({ validate });
    const isFileSystemEntry = (o) => "FileSystemEntry" in window && o instanceof window.FileSystemEntry;
    const isFileSystemFileEntry = (o) => "FileSystemFileEntry" in window && o instanceof window.FileSystemFileEntry;
    const validationMessage = ref("");
    const incomingPreview = ref();
    const existingPreview = ref();
    const incomingMTime = ref();
    const existingMTime = ref();
    const incomingSize = ref();
    const existingSize = ref();
    const conflictResolved = computed(() => incomingSelected.value || existingSelected.value);
    const isExistingFolder = computed(() => props.existing.type === FileType.Folder);
    const isIncomingFolder = computed(() => {
      if (isFileSystemEntry(props.incoming)) {
        return props.incoming.isDirectory;
      } else if (props.incoming instanceof File) {
        return false;
      }
      return props.incoming.type === FileType.Folder;
    });
    watch(() => props.existing, async () => {
      existingMTime.value = getMTime(props.existing);
      existingSize.value = getSize(props.existing);
      existingPreview.value = await getPreview(props.existing);
    });
    watch(() => props.incoming, async () => {
      const file = await getFileOrNode(props.incoming);
      if (file === null) {
        return;
      }
      incomingMTime.value = getMTime(file);
      incomingSize.value = getSize(file);
      incomingPreview.value = await getPreview(file);
    });
    async function getFileOrNode(input) {
      if (isFileSystemFileEntry(input)) {
        return await new Promise((resolve, reject) => input.file(resolve, reject));
      } else if (isFileSystemEntry(input)) {
        return null;
      }
      return input;
    }
    function getSize(input) {
      return input.size;
    }
    function getMTime(input) {
      if (input instanceof File) {
        const mtime = input.lastModified;
        if (mtime > 0) {
          return new Date(mtime);
        }
      } else {
        return input.mtime;
      }
    }
    async function getPreview(input) {
      if (input instanceof File) {
        return await getFilePreview(input);
      }
      return getPreviewURL(input, { size: PREVIEW_SIZE })?.toString();
    }
    async function getFilePreview(file) {
      if (!file.type.startsWith("image/")) {
        return void 0;
      }
      const { resolve, promise } = Promise.withResolvers();
      const reader = new FileReader();
      reader.onload = async (e) => {
        const result = e?.target?.result;
        if (result instanceof ArrayBuffer) {
          const blob = new Blob([result], { type: file.type });
          const url = URL.createObjectURL(blob);
          resolve(url);
          return;
        }
        resolve(void 0);
      };
      reader.readAsArrayBuffer(file);
      return promise;
    }
    function validate() {
      validationMessage.value = !incomingSelected.value && !existingSelected.value ? t("You need to choose at least one conflict solution") : "";
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", {
        class: normalizeClass(_ctx.$style.pickerEntry)
      }, [
        createElementVNode("legend", null, toDisplayString(__props.existing.basename), 1),
        createVNode(unref(NcCheckboxRadioSwitch), {
          modelValue: incomingSelected.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => incomingSelected.value = $event),
          error: !!validationMessage.value,
          "helper-text": validationMessage.value,
          required: !conflictResolved.value
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: normalizeClass(_ctx.$style.pickerEntryItem)
            }, [
              !incomingPreview.value ? (openBlock(), createBlock(unref(NcIconSvgWrapper), {
                key: 0,
                class: normalizeClass([_ctx.$style.pickerEntryIcon, { [_ctx.$style.pickerEntryIcon_folder]: isExistingFolder.value }]),
                path: isIncomingFolder.value ? unref(mdiFolder) : unref(mdiFile),
                size: 48
              }, null, 8, ["class", "path"])) : (openBlock(), createElementBlock("img", {
                key: 1,
                class: normalizeClass(_ctx.$style.pickerEntryPreview),
                src: incomingPreview.value,
                alt: "",
                loading: "lazy"
              }, null, 10, _hoisted_1$1)),
              createElementVNode("span", {
                class: normalizeClass(_ctx.$style.pickerEntryDescription)
              }, [
                createElementVNode("span", null, toDisplayString(unref(t)("New version")), 1),
                incomingMTime.value ? (openBlock(), createBlock(unref(NcDateTime), {
                  key: 0,
                  timestamp: incomingMTime.value,
                  "relative-time": false,
                  format: { timeStyle: "short", dateStyle: "medium" }
                }, null, 8, ["timestamp"])) : (openBlock(), createElementBlock("span", _hoisted_2$1, toDisplayString(unref(t)("Last modified date unknown")), 1)),
                createElementVNode("span", null, toDisplayString(incomingSize.value), 1)
              ], 2)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "error", "helper-text", "required"]),
        createVNode(unref(NcCheckboxRadioSwitch), {
          modelValue: existingSelected.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => existingSelected.value = $event),
          error: !!validationMessage.value,
          "helper-text": validationMessage.value,
          required: !conflictResolved.value
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: normalizeClass(_ctx.$style.pickerEntryItem)
            }, [
              !existingPreview.value ? (openBlock(), createBlock(unref(NcIconSvgWrapper), {
                key: 0,
                class: normalizeClass([_ctx.$style.pickerEntryIcon, { [_ctx.$style.pickerEntryIcon_folder]: isExistingFolder.value }]),
                path: isExistingFolder.value ? unref(mdiFolder) : unref(mdiFile),
                size: 48
              }, null, 8, ["class", "path"])) : (openBlock(), createElementBlock("img", {
                key: 1,
                class: normalizeClass(_ctx.$style.pickerEntryPreview),
                src: existingPreview.value,
                alt: "",
                loading: "lazy"
              }, null, 10, _hoisted_3)),
              createElementVNode("span", {
                class: normalizeClass(_ctx.$style.pickerEntryDescription)
              }, [
                createElementVNode("span", null, toDisplayString(unref(t)("Existing version")), 1),
                existingMTime.value ? (openBlock(), createBlock(unref(NcDateTime), {
                  key: 0,
                  timestamp: existingMTime.value,
                  "relative-time": false,
                  format: { timeStyle: "short", dateStyle: "medium" }
                }, null, 8, ["timestamp"])) : (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(unref(t)("Last modified date unknown")), 1)),
                createElementVNode("span", null, toDisplayString(existingSize.value), 1)
              ], 2)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "error", "helper-text", "required"])
      ], 2);
    };
  }
});
const pickerEntry = "_pickerEntry_xk2pl_1";
const pickerEntryItem = "_pickerEntryItem_xk2pl_5";
const pickerEntryIcon = "_pickerEntryIcon_xk2pl_11";
const pickerEntryPreview = "_pickerEntryPreview_xk2pl_12";
const pickerEntryIcon_folder = "_pickerEntryIcon_folder_xk2pl_24";
const pickerEntryDescription = "_pickerEntryDescription_xk2pl_34";
const style0$1 = {
  pickerEntry,
  pickerEntryItem,
  pickerEntryIcon,
  pickerEntryPreview,
  pickerEntryIcon_folder,
  pickerEntryDescription
};
const cssModules$1 = {
  "$style": style0$1
};
const ConflictPickerEntry = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__cssModules", cssModules$1]]);
const _hoisted_1 = { class: "hidden-visually" };
const _hoisted_2 = {
  key: 0,
  class: "hidden-visually"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ConflictPicker",
  props: {
    container: {},
    dirname: {},
    existing: {},
    incoming: {},
    recursiveUpload: { type: Boolean }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const blockedTitle = t("You need to select at least one version of each file to continue.");
    const formElement = useTemplateRef("form");
    const conflictEntries = useTemplateRef("conflictEntry");
    const newSelected = shallowRef([]);
    const oldSelected = shallowRef([]);
    const isNoNewSelected = computed(() => newSelected.value.length === 0);
    const areAllNewSelected = computed(() => newSelected.value.length === props.incoming.length);
    const areSomeNewSelected = computed(() => !areAllNewSelected.value && !isNoNewSelected.value);
    const areAllOldSelected = computed(() => oldSelected.value.length === props.existing.length);
    const areSomeOldSelected = computed(() => !areAllOldSelected.value && !isNoNewSelected.value);
    const areConflictsResolved = computed(() => {
      for (const conflict of props.incoming) {
        if (oldSelected.value.includes(conflict) || newSelected.value.includes(conflict)) {
          continue;
        }
        return false;
      }
      return true;
    });
    const dialogName = computed(() => props.dirname?.trim() !== "" ? n("%n file conflict in {dirname}", "%n file conflicts in {dirname}", props.incoming.length, { dirname: props.dirname }) : n("%n file conflict", "%n files conflict", props.incoming.length));
    function onCancel() {
      emit("close", null);
    }
    function onSkipAll() {
      logger.debug("Conflict skipped. Ignoring all conflicting files");
      emit("close", {
        selected: [],
        renamed: [],
        skipped: [...props.incoming]
      });
    }
    function onSelectAllNew(selected) {
      if (selected) {
        logger.debug("Selected all new files");
        newSelected.value = [...props.incoming];
      } else {
        logger.debug("Cleared new selection");
        newSelected.value = [];
      }
    }
    function onSelectAllOld(selected) {
      if (selected) {
        logger.debug("Selected all existing files");
        oldSelected.value = [...props.incoming];
      } else {
        logger.debug("Cleared old selection");
        oldSelected.value = [];
      }
    }
    function toggleOldSelected(conflict) {
      if (oldSelected.value.includes(conflict)) {
        oldSelected.value = oldSelected.value.filter((entry) => entry !== conflict);
      } else {
        oldSelected.value = [...oldSelected.value, conflict];
      }
    }
    function toggleNewSelected(conflict) {
      if (newSelected.value.includes(conflict)) {
        newSelected.value = newSelected.value.filter((entry) => entry !== conflict);
      } else {
        newSelected.value = [...newSelected.value, conflict];
      }
    }
    function onSubmit() {
      if (!areConflictsResolved.value) {
        for (const entry of conflictEntries.value) {
          entry.validate();
        }
        formElement.value.reportValidity();
        showError(blockedTitle);
        return;
      }
      const selected = newSelected.value.filter((entry) => !oldSelected.value.includes(entry));
      const renamed = newSelected.value.filter((entry) => oldSelected.value.includes(entry));
      const skipped = oldSelected.value.filter((entry) => !newSelected.value.includes(entry));
      emit("close", {
        renamed,
        selected,
        skipped
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NcDialog), {
        container: __props.container,
        class: normalizeClass(_ctx.$style.picker),
        name: dialogName.value,
        size: "large",
        onClosing: onCancel
      }, {
        actions: withCtx(() => [
          createVNode(unref(NcButton), {
            title: unref(t)("Cancel the entire operation"),
            "data-cy-conflict-picker-cancel": "",
            variant: "tertiary",
            onClick: onCancel
          }, {
            icon: withCtx(() => [
              createVNode(unref(NcIconSvgWrapper), { path: unref(mdiClose) }, null, 8, ["path"])
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(unref(t)("Cancel")), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          createElementVNode("span", {
            class: normalizeClass(_ctx.$style.pickerActionSeparator)
          }, null, 2),
          createVNode(unref(NcButton), { onClick: onSkipAll }, {
            icon: withCtx(() => [
              createVNode(unref(NcIconSvgWrapper), { path: unref(mdiClose) }, null, 8, ["path"])
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(__props.incoming.length === 1 ? unref(t)("Skip this file") : unref(n)("Skip %n file", "Skip %n files", __props.incoming.length)), 1)
            ]),
            _: 1
          }),
          createVNode(unref(NcButton), {
            "aria-disabled": !areConflictsResolved.value,
            class: normalizeClass([
              _ctx.$style.pickerActionSubmit,
              {
                [_ctx.$style.pickerActionSubmit_disabled]: !areConflictsResolved.value
              }
            ]),
            title: areConflictsResolved.value ? "" : unref(blockedTitle),
            type: "submit",
            variant: "primary",
            onClick: withModifiers(onSubmit, ["stop", "prevent"])
          }, {
            icon: withCtx(() => [
              createVNode(unref(NcIconSvgWrapper), {
                directional: "",
                path: unref(mdiArrowRight)
              }, null, 8, ["path"])
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(unref(t)("Continue")) + " ", 1),
              !areConflictsResolved.value ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(unref(blockedTitle)), 1)) : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-disabled", "class", "title"])
        ]),
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(_ctx.$style.pickerHeader)
          }, [
            createElementVNode("p", {
              id: "conflict-picker-description",
              class: normalizeClass(_ctx.$style.pickerDescription)
            }, [
              createTextVNode(toDisplayString(unref(t)("Which files do you want to keep?")), 1),
              _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1)),
              createTextVNode(" " + toDisplayString(unref(t)("If you select both versions, the incoming file will have a number added to its name.")), 1),
              _cache[1] || (_cache[1] = createElementVNode("br", null, null, -1)),
              __props.recursiveUpload ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(unref(t)("When an incoming folder is selected, the content is written into the existing folder and a recursive conflict resolution is performed.")), 1)
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(unref(t)("When an incoming folder is selected, any conflicting files within it will also be overwritten.")), 1)
              ], 64))
            ], 2)
          ], 2),
          createElementVNode("form", {
            ref: "form",
            "aria-labelledby": "conflict-picker-description",
            class: normalizeClass(_ctx.$style.pickerForm),
            onSubmit: withModifiers(onSubmit, ["prevent", "stop"])
          }, [
            createElementVNode("fieldset", {
              class: normalizeClass(_ctx.$style.pickerSelectAll)
            }, [
              createElementVNode("legend", _hoisted_1, toDisplayString(unref(t)("Select all checkboxes")), 1),
              createVNode(unref(NcCheckboxRadioSwitch), {
                "model-value": areAllNewSelected.value,
                indeterminate: areSomeNewSelected.value,
                "onUpdate:modelValue": onSelectAllNew
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t)("Select all new files")), 1)
                ]),
                _: 1
              }, 8, ["model-value", "indeterminate"]),
              createVNode(unref(NcCheckboxRadioSwitch), {
                "model-value": areAllOldSelected.value,
                indeterminate: areSomeOldSelected.value,
                "onUpdate:modelValue": onSelectAllOld
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t)("Select all existing files")), 1)
                ]),
                _: 1
              }, 8, ["model-value", "indeterminate"])
            ], 2),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.existing, (node, index) => {
              return openBlock(), createBlock(ConflictPickerEntry, {
                ref_for: true,
                ref: "conflictEntry",
                key: node.fileid,
                incoming: __props.incoming[index],
                existing: node,
                "incoming-selected": newSelected.value.includes(__props.incoming[index]),
                "existing-selected": oldSelected.value.includes(__props.incoming[index]),
                "onUpdate:existingSelected": ($event) => toggleOldSelected(__props.incoming[index]),
                "onUpdate:incomingSelected": ($event) => toggleNewSelected(__props.incoming[index])
              }, null, 8, ["incoming", "existing", "incoming-selected", "existing-selected", "onUpdate:existingSelected", "onUpdate:incomingSelected"]);
            }), 128))
          ], 34)
        ]),
        _: 1
      }, 8, ["container", "class", "name"]);
    };
  }
});
const picker = "_picker_6q4ek_1";
const pickerHeader = "_pickerHeader_6q4ek_6";
const pickerForm = "_pickerForm_6q4ek_15";
const pickerActionSubmit_disabled = "_pickerActionSubmit_disabled_6q4ek_22";
const pickerSelectAll = "_pickerSelectAll_6q4ek_27";
const style0 = {
  picker,
  pickerHeader,
  pickerForm,
  pickerActionSubmit_disabled,
  pickerSelectAll,
  "conflict-picker__all": "_conflict-picker__all_6q4ek_40"
};
const cssModules = {
  "$style": style0
};
const ConflictPicker = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  ConflictPicker as default
};
//# sourceMappingURL=ConflictPicker-D11j2xek.mjs.map
